import { useSelector } from "react-redux";

import { CRM_CHAT_FORCE_TOOL_TRACE_KEY } from "../constants/chatConstants";
import { useChatAgentLoopFlag } from "./useChatAgentLoopFlag";

function isToolTraceMetaDisabled(): boolean {
  if (typeof document === "undefined") return false;
  const meta = document.querySelector('meta[name="chat.toolTrace"]');
  return meta?.getAttribute("content") === "false";
}

/**
 * Tool trace panel visibility (story 3.23). Write confirmation stays on whenever agent loop is enabled.
 */
export function useChatToolTraceFlag(): boolean {
  const agentLoopEnabled = useChatAgentLoopFlag();

  let qaOverride = false;
  try {
    qaOverride =
      typeof window !== "undefined" &&
      window.sessionStorage.getItem(CRM_CHAT_FORCE_TOOL_TRACE_KEY) === "1";
  } catch {
    qaOverride = false;
  }

  if (!agentLoopEnabled) return false;
  if (qaOverride) return true;
  return !isToolTraceMetaDisabled();
}

/** Workspace admin — maps to MANAGE_WORKSPACE for PII redaction v1. */
export function useCanViewSensitiveToolArguments(): boolean {
  return useSelector(
    (state: { userReducer?: { getIn: (path: string[]) => unknown } }) =>
      state.userReducer?.getIn(["currentUser", "admin"]) === true
  );
}
